import { useQuery } from '@tanstack/react-query';
import { fetchOCClaimInitialValues } from '../data-provider/over-charge-claim-initial-values';
import type { GetOCClaimInitialValuesRequestParams } from '../data-provider/over-charge-claim-initial-values/api';

// TODO: investigate if companyId affects result useGetOCClaimInitialValues
export const useGetOCClaimInitialValues = ({
  companyId,
  ...params
}: GetOCClaimInitialValuesRequestParams & { companyId: number }) => {
  return useQuery({
    queryKey: ['claims-loss-and-damage-create-claim-initial-values', companyId, params.carrierKey],
    queryFn: () => fetchOCClaimInitialValues(params),
    staleTime: 1000 * 5, // 5 seconds (to avoid multiple calls)
    enabled: !!companyId,
  });
};
